jQuery(document).ready(function(){
    $('#check-menu').click(function(){
        $("body, html").toggleClass('hidden');
    });
    $('#check-filter').click(function(){
        $("body").toggleClass('hidden');
    });
    $('.simplebox, .close-modal, .close-search').click(function(){
        $("body, html").toggleClass('hidden-modal');
    });
    $('.top-slider').gallery({
        infinite: true,
        touch: true
    });
    $('.auto-slider').slick({
        variableWidth: true,
        arrows: false,
        infinite: true,
        speed: 10000,
        autoplay: true,
        autoplaySpeed: 0,
        draggable: false,
        pauseOnHover: false,
        cssEase: 'linear'
    });
    $('.fade-slider-head').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.fade-slider-body'
    });
    $('.fade-slider-body').slick({
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        focusOnSelect: true,
        asNavFor: '.fade-slider-head',
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 719,
                settings: {
                    variableWidth: true
                }
            }
        ]
    });
    $('.fade-gallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 7000,
        asNavFor: '.slider-hold, .sessions-hold'/*,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    adaptiveHeight: true
                }
            }
        ]*/
    });
    $('.slider-hold').slick({
        variableWidth: true,
        arrows: false,
        focusOnSelect: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 7000,
        asNavFor: '.fade-gallery'
    });
    $('.sessions-hold').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        focusOnSelect: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 7000,
        asNavFor: '.fade-gallery'/*,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    adaptiveHeight: true
                }
            }
        ]*/
    });
    $('.arrows-box .arrow-next').on('click', function() {
        $('.fade-gallery, .slider-hold, .sessions-hold').slick('slickNext');
    });
    $('.arrows-box .arrow-prev').on('click', function() {
        $('.fade-gallery, .slider-hold, .sessions-hold').slick('slickPrev');
    });
    $('.tabs-box').tabs();

    $('.simplebox').simplebox({
        overlay: {
            color: 'black',
            opacity: 0.23
        },
        linkClose: '.close-modal'
    });
    openClose();

    OpenBox({
        wrap: '.open-wrap',
        link: '.drop-btn',
        box: '.open-drop',
        openClass: 'open',
    });
});

function getTimeRemaining(endtime) {
    var t = Date.parse(endtime) - Date.now();
    var seconds = Math.floor((t / 1000) % 60);
    var minutes = Math.floor((t / 1000 / 60) % 60);
    var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    var days = Math.floor(t / (1000 * 60 * 60 * 24));
    return {
        'total': t,
        'days': days,
        'hours': hours,
        'minutes': minutes,
        'seconds': seconds
    };
}
function initializeClock(id, endtime) {
    var clock = document.getElementById(id);
    var daysSpan = clock.querySelector(".days");
    var hoursSpan = clock.querySelector(".hours");
    var minutesSpan = clock.querySelector(".minutes");
    var secondsSpan = clock.querySelector(".seconds");

    function updateClock() {
        var t = getTimeRemaining(endtime);

        if (t.total <= 0) {
            document.getElementById("timer").className = "timer-hidden";
            clearInterval(timeinterval);
            return true;
        }

        daysSpan.innerHTML = t.days;
        hoursSpan.innerHTML = ("0" + t.hours).slice(-2);
        minutesSpan.innerHTML = ("0" + t.minutes).slice(-2);
        secondsSpan.innerHTML = ("0" + t.seconds).slice(-2);
    }

    updateClock();
    var timeinterval = setInterval(updateClock, 1000);
}
var deadline = new Date(Date.parse('17 Oct 2020 19:00:00 GMT-4'));
initializeClock('timer', deadline);

function openClose() {
    var wrap = $('.openclose-box, .openclose-box02').each(function () {
        var boxed = $(this);
        var link = boxed.find('.openclose-head, .openclose-head02');
        var boxOpen = boxed.find('.openclose-body, .openclose-body02');

        boxOpen.css('display', 'none');
        boxed.removeClass('open')
        link.on('click', function (e) {
            if (!boxed.hasClass('open')) {
                boxed.addClass('open');
                boxOpen.slideUp(0).slideDown(400);
            }
            else {
                boxOpen.slideUp(400, function () {
                    boxed.removeClass('open');
                });
            }
            return false;
        });
    });
}

function OpenBox(obj){
    $(obj.wrap).each(function(){
        var hold = $(this);
        var link = hold.find(obj.link);
        var box = hold.find(obj.box);
        var w = obj.w;
        var close = hold.find(obj.close);

        link.click(function(){
            $(obj.wrap).not(hold).removeClass(obj.openClass);
            if (!hold.hasClass(obj.openClass)) {
                hold.addClass(obj.openClass);
            }
            else {
                hold.removeClass(obj.openClass);
            }
            return false;
        });

        hold.hover(function(){
            $(this).addClass('hovering');
        }, function(){
            $(this).removeClass('hovering');
        });

        $("body").click(function(){
            if (!hold.hasClass('hovering')) {
                hold.removeClass(obj.openClass);
            }
        });
        close.click(function(){
            hold.removeClass(obj.openClass);

            return false;
        });

        jQuery(document).bind('touchstart mousedown', function(e){
            if(!(jQuery(e.target).parents().index(hold) != -1 || jQuery(e.target).index(hold) != -1)){
                hold.removeClass(obj.openClass);
            }
        });
    });
};